/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from "react";
import EntryAndExitFormListSection from "../../Details/EntryAndExitFormListSection";
import EntryAndExitFormDetailsSectionInfo from "../../Details/EntryAndExitFormDetailsSectionInfo";
import {permissionObj} from "../../../../../../../Helpers/permission";
import routes from "../../../../../../../Routes/routes";
import DivContainerBody from "../../../../../../../components/DivContainerBody";
import HeadTittle from "../../../../../../../components/HeadTittle";
import CustomChip from "../../../../../../../components/CustomChip";
import {colors} from "../../../../../../../enums/colors";
import StatusBadgeSection from "../../Details/Sections/StatusBadgeSection";
import {STATUS_MODEL} from "../../../../../../../enums/statusEnum";

const LivePoultryTruckDetails = (props) => {
    const {
        t,
        navigate,
        DEV,
        permission,
        contentCardRef,
        contentTableRef,
        containerCardRef,
        containerTableRef,
        item,
        goBack,
        evidence,
        form,
        showBadge,
        pendingGateTrans,
        // The detail is opened from the tab of the forms and from the one of the
        // requests, so it is read with the permission of the module it comes from
        readPermission = permissionObj.WEB_ENTRY_AND_EXIT_FORMS_READ
    } = props;

    if (!DEV &&
        !permission?.includes(readPermission)
    )
        navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                name={'details'}
                onBack={goBack}
                divStack={
                    <CustomChip legend={t(form.trans)}
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                variant={'compact'}
                                icon={form.Icon}
                                classNameIcon={'icon-color-secondary-700 h-16px w-16px'}
                    />
                }
            >
            </HeadTittle>
            <DivContainerBody>
                <div className={"mb-4"}>
                    {/* The movement the gate registered is read in the log of
                        the folio, so the dispatch that closed it is not
                        announced again at the top; the report that has to be
                        attended is the only result read there. */}
                    <StatusBadgeSection
                        t={t}
                        item={item}
                        showBadge={showBadge && item?.dispatchStatusId === STATUS_MODEL.DISCREPANCY}
                        pendingTrans={pendingGateTrans}
                    />
                </div>
                <div className='row px-0'>
                    <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0 pr-sm-0 pr-md-3'
                         ref={containerCardRef}>
                        <EntryAndExitFormDetailsSectionInfo
                            item={item}
                            evidence={evidence}
                            form={form}
                            contentCardRef={contentCardRef}
                            // The observations are read in the exit of the gate log, so
                            // the card does not repeat them
                            showNotes={false}
                        />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-8 px-0' ref={containerTableRef}>
                        <EntryAndExitFormListSection
                            contentTableRef={contentTableRef}
                            data={item}
                            form={form}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default LivePoultryTruckDetails;
